import React from 'react';
import { MapPin } from 'lucide-react';
import type { SupplierShipToAddress } from '../../types';
import './SupplierShipToLine.css';

export type SupplierShipToLineProps = {
  address: SupplierShipToAddress;
  /** `card` — supplier RFQ panels; `portal` — vendor portal work panel */
  variant?: 'card' | 'portal';
  className?: string;
};

function hasShipToContent(address: SupplierShipToAddress): boolean {
  return Boolean(
    address.recipient?.trim()
    || address.line1?.trim()
    || address.line2?.trim()
    || address.city?.trim()
    || address.state?.trim()
    || address.zip?.trim(),
  );
}

function formatCityStateZip(address: SupplierShipToAddress): string {
  const cityLine = [address.city?.trim(), address.state?.trim()].filter(Boolean).join(', ');
  return [cityLine, address.zip?.trim()].filter(Boolean).join(' ').trim();
}

const SupplierShipToLine: React.FC<SupplierShipToLineProps> = ({
  address,
  variant = 'card',
  className = '',
}) => {
  if (!hasShipToContent(address)) return null;

  const recipient = address.recipient?.trim();
  const streetLine = [address.line1?.trim(), address.line2?.trim()].filter(Boolean).join(', ');
  const cityLine = formatCityStateZip(address);

  return (
    <div
      className={`supplier-ship-to supplier-ship-to--${variant} ${className}`.trim()}
      role="group"
      aria-label="Delivery address"
    >
      <div className="supplier-ship-to-icon-wrap" aria-hidden>
        <MapPin size={12} strokeWidth={2.25} />
      </div>
      <div className="supplier-ship-to-content">
        <span className="supplier-ship-to-kicker">Delivery</span>
        {recipient && <span className="supplier-ship-to-primary">{recipient}</span>}
        {streetLine && <span className="supplier-ship-to-secondary">{streetLine}</span>}
        {cityLine && <span className="supplier-ship-to-secondary">{cityLine}</span>}
      </div>
    </div>
  );
};

export default SupplierShipToLine;
